import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ShieldCheck, Lock, Eye, Globe2, FileCheck, Activity } from 'lucide-react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';
import RichText from '../components/RichText';

export default function SecurityPage() {
  const { t, seo } = usePage('security');
  const pillars = [
    { Icon: ShieldCheck, n: '01', title: t('pillar_1_title', 'ClicksyHub Microservices'), desc: t('pillar_1_desc', '') },
    { Icon: Lock, n: '02', title: t('pillar_2_title', 'ClicksyHub Shield Advance'), desc: t('pillar_2_desc', '') },
    { Icon: Eye, n: '03', title: t('pillar_3_title', 'Identity & Access'), desc: t('pillar_3_desc', '') },
    { Icon: Globe2, n: '04', title: t('pillar_4_title', 'Data sovereignty'), desc: t('pillar_4_desc', '') },
    { Icon: FileCheck, n: '05', title: t('pillar_5_title', 'Compliance-ready'), desc: t('pillar_5_desc', '') },
    { Icon: Activity, n: '06', title: t('pillar_6_title', 'Capacity that scales'), desc: t('pillar_6_desc', '') },
  ];
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} image={seo.og_image} />
      <section className="pt-24 pb-16 lg:pt-36 lg:pb-24">
        <div className="container-x">
          <span className="eyebrow">{t('hero_eyebrow', 'Security')}</span>
          <h1 className="heading-display mt-8 text-[44px] sm:text-[64px] lg:text-[96px] max-w-5xl">{t('hero_title', 'Financial-grade security in every byte we move')}</h1>
          <p className="mt-8 text-[16px] text-[#C6C4CF] max-w-2xl"><RichText text={t('hero_description', '')} /></p>
        </div>
      </section>
      <section className="py-16 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {pillars.map((p) => (
            <div key={p.n} className="group">
              <div className="w-12 h-12 rounded-full border border-[#C6C4CF] text-[#C6C4CF] flex items-center justify-center group-hover:bg-[#F5F137] group-hover:text-[#232323] transition-colors"><p.Icon size={20} /></div>
              <p className="text-[#F5F137] text-sm tracking-[0.28em] font-medium mt-6">{p.n}</p>
              <h3 className="heading-display text-2xl lg:text-3xl mt-2">{p.title}</h3>
              <p className="mt-3 text-[#C6C4CF] leading-relaxed text-[15px]"><RichText text={p.desc} /></p>
            </div>
          ))}
        </div>
      </section>
      <section className="py-24 lg:py-32 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="aspect-[4/3] overflow-hidden bg-[#2A2A2A]">
              <img src="/images/slider-3.webp" alt="" className="w-full h-full object-cover grayscale-[30%]" loading="lazy" />
            </div>
          </div>
          <div className="lg:col-span-6">
            <span className="eyebrow">{t('commitment_title', 'Our security commitment')}</span>
            <h2 className="heading-display text-[36px] lg:text-[56px] mt-8">{t('commitment_title', 'Our security commitment')}</h2>
            <p className="mt-6 text-[#C6C4CF] text-[16px] leading-relaxed"><RichText text={t('commitment_text', '')} /></p>
            <Link to="/contact" className="btn-outline mt-8"><span>Request a security review</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
